import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { MoveResource } from "../../../components/Resource/MoveResource";
import { useParams } from "react-router-dom";

export interface IMoveResourcePage {}

export const MoveResourcePage: FC<IMoveResourcePage> = () => {
  const { resourceName } = useParams();
  
  return (
    <AuthenticatedLayout
      pageTitle={`Move ${resourceName !== 'T5_Recipient' ? resourceName : 'T5 Recipient'}s`}
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        {
          text: `Move ${resourceName !== 'T5_Recipient' ? resourceName : 'T5 Recipient'}s`,
          navigateTo: `/resources/${resourceName}/move-people`,
        },
      ]}
      mainContents={<MoveResource />}
    />
  );
};
